import styled from 'styled-components';

export const LogoutModalContent = styled.div`
  background-color: white;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
`;
